import { useMutation, useQuery } from '@tanstack/react-query';
import importJobService from '../../../services/importJobService';

const POLL_MS = 2000;

// Mạng, quá giờ, 408/429 hay 5xx (lúc deploy) thì hỏi lại sẽ hồi; 4xx khác hay id sai thì hỏi mãi cũng vậy
const isTransient = (error: unknown) => {
  const { response, code } = (error ?? {}) as { response?: { status: number }; code?: string };
  return response
    ? response.status >= 500 || response.status === 408 || response.status === 429
    : code === 'ERR_NETWORK' || code === 'ECONNABORTED' || code === 'ETIMEDOUT';
};

export const useStartActivationJob = () =>
  useMutation({
    mutationFn: (file: File) => importJobService.startActivation(file),
    // Gửi lại là tạo thêm một job kích hoạt cùng file
    retry: false,
  });

export const useRecentActivationJobs = (enabled: boolean) =>
  useQuery({
    queryKey: ['import-jobs', 'activations'],
    queryFn: () => importJobService.listActivations(),
    enabled,
    // App giữ cache 10 phút và không tải lại khi mount; danh sách này phải mới mỗi lần vào trang,
    // không thì job vừa tạo ở lần trước không hiện
    staleTime: 0,
    refetchOnMount: 'always',
    // Còn job chưa xong thì làm mới để danh sách không đứng ở tiến độ cũ
    refetchInterval: (query) =>
      query.state.data?.some((job) => job.status === 'queued' || job.status === 'processing') ? POLL_MS * 5 : false,
  });

export const useImportJob = (id: string | null) =>
  useQuery({
    queryKey: ['import-job', id],
    queryFn: () => importJobService.get(id as string),
    enabled: !!id,
    refetchInterval: (query) => {
      const { data, status, error } = query.state;
      // Chưa lấy được job lần nào: chỉ thôi hỏi khi lỗi không tự hồi được (job không có, id sai)
      if (!data) return status === 'error' && !isTransient(error) ? false : POLL_MS;
      return data.status === 'completed' || data.status === 'failed' ? false : POLL_MS;
    },
  });
